import { useEffect } from 'react';
import { usePriorityRendererShallowStore } from '../store/priority-renderer.store';

export const useInitPriorityRendererGroup = ({
  groupName,
  priorityList,
  resetPriorityMap = false,
}: {
  groupName: string;
  priorityList: string[];
  resetPriorityMap?: boolean;
}) => {
  const { initializeGroup } = usePriorityRendererShallowStore('initializeGroup');
  useEffect(() => {
    initializeGroup?.({ groupName, priorityList, resetPriorityMap });
  }, [groupName, priorityList, initializeGroup, resetPriorityMap]);
};
